import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileDown, FileSpreadsheet, ChevronDown } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { fmtEUR, fmtEUR2, fmtDate } from "@/lib/format";
import { CARD, Label, Loader } from "@/components/common";
import { Button } from "@/components/ui/button";

const download = (url, params, name) => api.get(url, { params, responseType: "blob" }).then((r) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = name;
  a.click();
  URL.revokeObjectURL(a.href);
}).catch((e) => toast.error(apiErr(e)));

function Group({ g }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="px-5 py-3.5" data-testid="relance-group">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <button type="button" onClick={() => setOpen(!open)} className="flex min-w-0 items-center gap-2 text-left" data-testid="relance-toggle">
          <ChevronDown className={`h-4 w-4 shrink-0 text-gray-400 transition-transform ${open ? "rotate-180" : ""}`} />
          <div className="min-w-0"><p className="truncate font-semibold">{g.payer}</p><p className="text-xs text-gray-400">{g.count} paiement(s) · le plus ancien : {g.oldest_days} jours</p></div>
        </button>
        <div className="flex items-center gap-3"><span className="font-semibold tabular-nums">{fmtEUR2(g.amount)}</span>
          <Button size="sm" variant="outline" onClick={() => download("/tiers-payant/relances/pdf", { payer: g.payer }, `relance_${g.payer}.pdf`)} data-testid="relance-pdf"><FileDown className="mr-1.5 h-4 w-4" />PDF de relance</Button></div>
      </div>
      {open && <div className="mt-2 divide-y divide-gray-50 pl-6 text-sm">{g.items.map((i) => (
        <div key={i.transaction_id} className="flex justify-between gap-3 py-1.5"><span className="truncate">{i.patient} · soins {fmtDate(i.act_date)}</span><span className="shrink-0 tabular-nums">{fmtEUR2(i.amount)} · {i.age_days} j</span></div>))}</div>}
    </div>
  );
}

export function Relances() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/tiers-payant/relances").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (d === null) return <Loader />;
  if (d === false) return null;
  return (
    <div data-testid="relances">
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
        <Label>Relances mutuelles · impayés depuis plus de 30 jours après les soins</Label>
        <Button size="sm" variant="outline" onClick={() => download("/tiers-payant/relances/xlsx", {}, "impayes_tiers_payant.xlsx")} data-testid="relances-xlsx"><FileSpreadsheet className="mr-1.5 h-4 w-4" />Excel de tous les impayés</Button>
      </div>
      <div className={`${CARD} divide-y divide-gray-100`}>
        {d.groups.length ? <p className="px-5 py-3 text-sm text-gray-600" data-testid="relances-total">{d.count} paiement(s) à relancer · <b>{fmtEUR(d.total)}</b></p> : null}
        {d.groups.map((g) => <Group key={g.payer} g={g} />)}
        {!d.groups.length && <p className="p-8 text-center text-sm text-gray-400">Aucun paiement mutuelle en attente depuis plus de 30 jours.</p>}
      </div>
    </div>
  );
}
